import { useTranslation } from "react-i18next";
import React, { useState } from "react";

import { ChapterStatsDto, LessonStatsDto } from "../../interfaces";
import { QuestionStatisticsPage } from "./QuestionStatisticsPage";
import { QuestionsTabsPage } from "./QuestionsTabsPage";
import { useParams } from "react-router-dom";

export const QuestionsLayoutPage = () => {
  //#region hooks
  const { t, i18n } = useTranslation();
  const { subjectId } = useParams<any>();
  //#endregion

  //#region internal state
  const [page, setPage] = useState<number>(1);
  const [selectedChapterStats, setSelectedChapterStats] =
    useState<ChapterStatsDto | null>(null);
  const [selectedLessonStats, setSelectedLessonStats] =
    useState<LessonStatsDto | null>(null);
  //#endregion

  document.title = `${t("documentTitle", { pageName: "questions" })}`;

  //#region handlers

  const onViewQuestions = (
    chapter: ChapterStatsDto,
    lesson: LessonStatsDto
  ) => {
    setPage(2);
    setSelectedChapterStats(chapter);
    setSelectedLessonStats(lesson);
  };
  //#endregion

  const getHeader = () => {
    try {
      return (
        <React.Fragment>
          <span className="cursor-pointer" onClick={() => setPage(1)}>
            {t("questionsStats")}
          </span>
          {i18n.language === "ar" ? (
            <i className="ri-arrow-left-s-line align-bottom text-muted"></i>
          ) : (
            <i className="ri-arrow-right-s-line align-bottom text-muted"></i>
          )}
          <span className="text-muted">
            {i18n.language === "ar"
              ? selectedChapterStats?.name.ar
              : selectedChapterStats?.name.en}
          </span>
          {i18n.language === "ar" ? (
            <i className="ri-arrow-left-s-line align-bottom text-muted"></i>
          ) : (
            <i className="ri-arrow-right-s-line align-bottom text-muted"></i>
          )}
          <span className="text-muted">
            {i18n.language === "ar"
              ? selectedLessonStats?.name.ar
              : selectedLessonStats?.name.en}
          </span>
        </React.Fragment>
      );
    } catch (exception: any) {
      return t("question");
    }
  };

  //#endregion

  return (
    <React.Fragment>
      {page === 1 && (
        <QuestionStatisticsPage
          subjectId={subjectId}
          onViewQuestions={onViewQuestions}
        />
      )}
      {page === 2 && selectedLessonStats && (
        <QuestionsTabsPage
          subjectId={subjectId}
          lessonId={selectedLessonStats?.id}
          header={getHeader()}
        />
      )}
    </React.Fragment>
  );
};
